import { render, staticRenderFns } from "./index.vue?vue&type=template&id=957cbdac"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('957cbdac')) {
      api.createRecord('957cbdac', component.options)
    } else {
      api.reload('957cbdac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=957cbdac", function () {
      api.rerender('957cbdac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverse/edition/index.vue"
export default component.exports